import { Box, Container, Typography } from "@mui/material";
import { ServicesData } from "../../data/ServicesData";
import "./ServiceSection.css";

export default function ServiceSection() {
  return (
    <Box className="services-section">
      <Container>
        <Typography variant="h4" className="services-title" gutterBottom>
          What We Do
        </Typography>
        <Typography
          variant="subtitle1"
          className="services-subtitle"
          gutterBottom
        >
          See Our Best Services
        </Typography>
        <Box className="services-grid">
          {ServicesData.map((service) => (
            <Box className="service-card" key={service.id}>
              <Box className="service-icon">{service.icon}</Box>
              <Typography variant="h6" className="service-title">
                {service.title}
              </Typography>
              <ul className="service-points">
                {service.details.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
